module.exports = __webpack_public_path__ + "media/images/gift/gift-items-line-dee32acb497736797cd6d75ced5f7802.png";